"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SessionValue = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _SessionStorage = require("./SessionStorage");
class SessionValue {
  constructor(key) {
    (0, _defineProperty2.default)(this, "key", void 0);
    (0, _defineProperty2.default)(this, "storage", new _SessionStorage.SessionStorage());
    (0, _defineProperty2.default)(this, "remove", () => {
      this.storage.removeItem(this.key);
      return this;
    });
    (0, _defineProperty2.default)(this, "get", () => this.storage.getItem(this.key));
    (0, _defineProperty2.default)(this, "set", value => {
      this.storage.setItem(this.key, value);
      return this;
    });
    this.key = key;
  }
}
exports.SessionValue = SessionValue;
